module.exports = __webpack_public_path__ + "static/media/logo.dceebb21.png";